/**
 * useLastApprenantId — mémorise le dernier apprenant ID visité dans localStorage.
 *
 * Pourquoi : Rafik 29/05/2026 — quand on navigue Apprenants → Documents → retour
 * Apprenants, on tombait sur Martine (demo-martine hardcodée). Désormais on
 * revient sur la dernière fiche réellement consultée.
 *
 * - getLastApprenantId() lit la valeur (string ou null)
 * - setLastApprenantId(id) écrit (sauf pour les IDs démo qu'on ne veut pas mémoriser)
 * - getNavTargetForApprenants() renvoie la cible idéale pour la nav Apprenants
 */
const STORAGE_KEY = 'v2:lastApprenantId';

export function setLastApprenantId(id: string): void {
  if (!id || id === 'demo-martine') return; // jamais mémoriser la démo
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // localStorage indisponible : pas grave
  }
}

export function getLastApprenantId(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function getNavTargetForApprenants(): string {
  const last = getLastApprenantId();
  return last ? `/apprenants/${last}` : '/apprenants';
}
